import React, { useState, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import { withStyles } from '@material-ui/core';
import DraggableListItem from './DraggableListItem';
import styles from './styles';

const DraggableList = React.memo(({ classes, items, onDragEnd, renderItem, orderKey = 'id' }) => {
  const [internalList, setInternalList] = useState(items);

  useEffect(() => {
    setInternalList(items);
  }, [items]);

  const isOrderChanged = (a, b, key) =>
    a.length === b.length && a.some((item, index) => item[key] !== b[index][key]);

  const handleSetList = (newList) => {
    if (isOrderChanged(newList, internalList, orderKey)) {
      onDragEnd(newList);
    }
    setInternalList(newList);
  };

  return (
    <ReactSortable
      list={internalList}
      setList={handleSetList}
      className={classes.draggableListContainer}
      handle="#draggableListIcon"
      chosenClass={classes.chosenItem}
      ghostClass={classes.ghostItem}
    >
      {internalList.map((item) => (
        <DraggableListItem
          RenderItem={renderItem}
          key={item[orderKey] ?? item.id ?? item.key}
          item={item}
        />
      ))}
    </ReactSortable>
  );
});

DraggableList.displayName = 'DraggableList';

export default withStyles(styles)(DraggableList);
